import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Plot from 'react-plotly.js';

function ExamsHistoryContent() {
  const [simulados, setSimulados] = useState([]);
  const [simuladoPerformances, setSimuladoPerformances] = useState({});
  const [viewMode, setViewMode] = useState("simplificado");

  const userID = localStorage.getItem('userID');
  const selectedSimuladoID = localStorage.getItem('selectedSimuladoID');

  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split('/');
    return new Date(`${year}-${month}-${day}`);
  };

  useEffect(() => {
    const fetchSimulados = async () => {
      if (!userID) {
        console.error('Nenhum ID de usuário encontrado');
        return;
      }

      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=get_simulados_by_aluno&ID_aluno=${userID}`);
        const data = await response.json();
        const simuladoIDs = data.simulado_IDs;
        const simuladoNames = data.simulado_names;
        const simuladoDates = data.simulado_datas;

        const simuladosData = simuladoIDs
          .map((id, index) => ({
            id,
            name: simuladoNames[index],
            date: simuladoDates[index],
          }))
          .sort((a, b) => parseDate(b.date) - parseDate(a.date));

        setSimulados(simuladosData);

        for (let simulado of simuladosData) {
          const performanceResponse = await fetch(
            `https://rvensino.com.br/get.php?action=getPerformance&ID_usuario=${userID}&ID_prova=${simulado.id}`
          );
          const performanceData = await performanceResponse.json();
          setSimuladoPerformances((prevPerformances) => ({
            ...prevPerformances,
            [simulado.id]: performanceData[0],
          }));
        }
      } catch (error) {
        console.error('Erro ao buscar simulados ou dados de performance: ', error);
      }
    };

    fetchSimulados();
  }, [userID]);

  const graphData = simulados.map((simulado) => {
    const performance = simuladoPerformances[simulado.id];
    return {
      date: simulado.date,
      grades: performance?.Notas || {},
    };
  });

  const getGraphData = () => {
    if (viewMode === "simplificado") {
      return [
        {
          x: [...dates].reverse(),
          y: filterValidGrades(graphData.map((item) => item.grades.Media_sem_redacao)).reverse(),
          type: 'scatter',
          mode: 'lines+markers',
          name: 'Média sem Redação',
          marker: { color: '#362191', size: 10 },
          line: { shape: 'linear', color: '#362191', width: 2 },
          connectgaps: true,
        },
        {
          x: [...dates].reverse(),
          y: filterValidGrades(graphData.map((item) => item.grades.Media_com_redacao)).reverse(),
          type: 'scatter',
          mode: 'lines+markers',
          name: 'Média com Redação',
          marker: { color: 'red', size: 8 },
          line: { shape: 'linear', color: 'red', width: 2 },
          connectgaps: true,
        },
      ].filter((data) => data.y.some((nota) => nota !== null));
    } else {
      const disciplinas = ["Ciencias_Humanas", "Ciencias_Natureza", "Linguagens", "Matematica", "Redacao"];
      const cores = {
        Ciencias_Humanas: "#ff9800",
        Ciencias_Natureza: "#4caf50",
        Linguagens: "#8e44ad",
        Matematica: "#e53935",
        Redacao: "#336699",
      };

      return disciplinas
        .map((disciplina) => ({
          x: [...dates].reverse(),
          y: filterValidGrades(graphData.map((item) => item.grades[disciplina])).reverse(),
          type: 'scatter',
          mode: 'lines+markers',
          name: disciplina.replace("_", " "),
          marker: { color: cores[disciplina], size: 8 },
          line: { shape: 'linear', color: cores[disciplina], width: 2 },
          connectgaps: true,
        }))
        .filter((data) => data.y.some((nota) => nota !== null));
    }
  };

  const roundToOneDecimal = (number) => {
    if (number === null || number === undefined || number === 0 || number === -1) return '-';
    return Number(number).toFixed(1).replace('.', ',')
  };

  

  const formatToMMYY = (dateString) => {
    const [day, month, year] = dateString.split('/');
    return `${month}/${year.slice(-2)}`;
  };

  const dates = graphData.map((item) => formatToMMYY(item.date));

  const filterValidGrades = (grades) =>
    grades.map((nota) => (nota !== null && nota !== undefined && nota !== 0 && nota !== -1 ? nota : null));



  if (!simulados.length || getGraphData().length === 0) {
    return (
      <div className='page-container'>
        <div className='empty'>Seu histórico de simulados ficará aqui</div>
      </div>
    );
  }
  

  const handleSimuladoClick = (simuladoID) => {
    localStorage.setItem('selectedSimuladoID', simuladoID);
  };

  
 
  return (
    <div className="exam-history-container">
      <div className="exam-list">
        {simulados?.map((simulado, index) => {
          const performance = simuladoPerformances[simulado.id];
          const mediaSemRedacao = roundToOneDecimal(performance?.Notas?.Media_sem_redacao);
          const mediaComRedacao = roundToOneDecimal(performance?.Notas?.Media_com_redacao);

          const mostRecentClass = index === 0 ? 'most-recent' : '';
          const isSelected = simulado.id === selectedSimuladoID;
          const selectedClass = isSelected ? 'selectedSimulado' : '';

          return (
            <Link
              to="/dashboard"
              className="no-link-style"
              key={simulado.id}
              onClick={() => handleSimuladoClick(simulado.id)}
            >
              <div className={`exam-history ${mostRecentClass} ${selectedClass}`}>
                <div className="exam-date">Simulado realizado em {simulado.date}</div>
                <div className="exam-grades">
                  <div className="exam-grade">
                    <div className="info">
                      <p className="info-card-note">{mediaSemRedacao}</p>
                      <p className="info-card-text">Média sem redação</p>
                    </div>
                  </div>
                  <div className="exam-grade-essay">
                    <div className="info">
                      <p className="info-card-note">{mediaComRedacao}</p>
                      <p className="info-card-text">Média com redação</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      
      {simulados.length > 0 && getGraphData().length > 0 && (
    <div className="graph-container">
      <h3 className="exams-graph-title">Evolução das Notas</h3>
      <Plot
        data={getGraphData()}
        layout={{
          title: "",
          titlefont: { size: 18 },
          showlegend: true,
          legend: {
            orientation: "h",
            x: 0.5,
            y: -0.2,
            xanchor: "center",
          },
          margin: { l: 50, r: 50, t: 50, b: 80 },
        }}
        style={{ width: "100%", height: "100%" }}
      />
      <div className="graph-buttons">
        <button onClick={() => setViewMode("simplificado")}>Visão Simplificada</button>
        <button onClick={() => setViewMode("detalhado")}>Visão Detalhada</button>
      </div>
    </div>
  )} 




    </div>
  );
}

export default ExamsHistoryContent;
